import { render, staticRenderFns } from "./AppDialog.vue?vue&type=template&id=330f22d2&"
import script from "./AppDialog.vue?vue&type=script&lang=ts&"
export * from "./AppDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports